import { useTranslation } from 'react-i18next';
import { useInView } from '@/hooks/useInView';

export default function Testimonial() {
  const { t } = useTranslation();
  const { ref, inView } = useInView<HTMLDivElement>(0.2);

  return (
    <section className="w-full bg-background-50 py-24 md:py-32 border-t border-background-200/70">
      <div ref={ref} className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 items-center">
          <div className="lg:col-span-3">
            <div className={`inline-flex items-center gap-2 text-xs font-mono-tech tracking-widest uppercase text-foreground-600 mb-8 ${inView ? 'animate-fade-up' : 'opacity-0'}`}>
              <span className="w-1.5 h-1.5 rounded-full bg-foreground-950" />
              {t('testimonial.tag')}
            </div>
            <blockquote
              className={`font-heading text-3xl md:text-5xl lg:text-6xl leading-[1.15] text-foreground-950 tracking-tight ${inView ? 'animate-fade-up' : 'opacity-0'}`}
              style={{ animationDelay: '0.15s' }}
            >
              <span className="text-primary-500 font-heading text-6xl md:text-7xl leading-none align-top mr-2">&ldquo;</span>
              {t('testimonial.quote')}
            </blockquote>

            <div
              className={`mt-10 flex items-center gap-4 ${inView ? 'animate-fade-up' : 'opacity-0'}`}
              style={{ animationDelay: '0.3s' }}
            >
              <div>
                <div className="font-heading text-lg font-semibold text-foreground-950">
                  {t('testimonial.author')}
                </div>
                <div className="text-sm text-foreground-600">
                  {t('testimonial.role')}
                </div>
              </div>
              <div className="flex items-center gap-2 pl-4 border-l border-background-300">
                <div className="w-6 h-6 flex items-center justify-center bg-primary-500 rounded-full">
                  <i className="ri-check-line text-foreground-950 text-sm w-4 h-4 flex items-center justify-center" />
                </div>
                <span className="text-xs font-mono-tech tracking-wider uppercase text-foreground-700">
                  {t('testimonial.verified')}
                </span>
              </div>
            </div>
          </div>

          <div
            className={`lg:col-span-2 relative aspect-[4/5] rounded-2xl overflow-hidden ${inView ? 'animate-slide-left' : 'opacity-0'}`}
            style={{ animationDelay: '0.2s' }}
          >
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20professional%20asian%20female%20executive%20portrait%20photography%2C%20natural%20window%20light%2C%20warm%20cream%20studio%20background%2C%20editorial%20fashion%20aesthetic%2C%20soft%20focus%20contemplative%20expression%2C%20premium%20magazine%20cover%20quality%2C%20half%20profile%20composition%20with%20subtle%20amber%20warm%20tones%2C%20cinematic%20natural%20portrait%20with%20clean%20minimal%20backdrop&width=800&height=1000&seq=testimonial-yvonne-01&orientation=portrait"
              alt={t('testimonial.author')}
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between">
              <span className="text-[10px] font-mono-tech tracking-widest uppercase text-background-50 bg-foreground-950/50 backdrop-blur-md px-3 py-1.5 rounded-full">
                Lumen Protocol · 2025
              </span>
              <span className="w-9 h-9 rounded-full bg-primary-500 flex items-center justify-center">
                <i className="ri-double-quotes-r text-foreground-950 text-lg w-5 h-5 flex items-center justify-center" />
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}